import { defineMessages } from 'react-intl';

export const clientsMessages = defineMessages({
    clientDashboard: {
        id: 'clientDashboard',
        defaultMessage: 'Client dashboard',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    validDays: {
        id: 'valid-days',
        defaultMessage: 'Valid days',
    },
    allowedDays: {
        id: 'allowed-days',
        defaultMessage: 'Allowed days',
    },
    allowedParkingSpaces: {
        id: 'allowed-parking-spaces',
        defaultMessage: 'Allowed parking spaces',
    },
    allowedZones: {
        id: 'allowed-zones',
        defaultMessage: 'Allowed zones',
    },
    allowedGateways: {
        id: 'allowed-gateways',
        defaultMessage: 'Allowed gateways',
    },
    closed: {
        id: 'closed',
        defaultMessage: 'Closed',
    },
    allGateways: {
        id: 'all-gateways',
        defaultMessage: 'All gateways',
    },
    notAllowedDay: {
        id: 'not-allowed-day',
        defaultMessage: 'Not allowed',
    },
});
